import styled from 'styled-components';
import { Dropdown as BSDropdown } from 'react-bootstrap';

import { MEDIUM_GREY } from 'constants/colours';

export const Dropdown = styled(BSDropdown)`
  display: flex;
  justify-content: flex-end;
`;

export const DropdownToggle = styled(Dropdown.Toggle)`
  color: ${MEDIUM_GREY};
`;

export const IconWrapper = styled.span`
  margin-right: 8px;
`;
